<template>
  <!-- 紧固件 待处理订单 -->
  <div class="order">
    <!-- 表单区域 -->
    <div class="serch-wrap">
      <el-form
        label-position="left"
        :inline="true"
        :model="orderForm"
        class="demo-form-inline"
      >
        <el-form-item label="主订单号">
          <el-input
            @keyup.enter.native="searchOrderList"
            v-model="orderForm.main_number"
            placeholder="主订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="子订单号">
          <el-input
            @keyup.enter.native="searchOrderList"
            v-model="orderForm.order_number"
            placeholder="子订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="编号" label-width="40px">
          <el-input v-model="orderForm.serialNumber"></el-input>
        </el-form-item>
        <!-- 主单状态 -->
        <el-form-item label="主单状态">
          <el-select
            v-model="orderForm.mainOrderStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in mainOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 同步状态 -->
        <el-form-item label="同步状态" v-if="syncStatusFlag">
          <el-select
            v-model="orderForm.syncStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in syncOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推送日期">
          <el-col :span="11">
            <el-date-picker
              type="datetime"
              placeholder="开始日期"
              v-model="orderForm.start_created_at"
              style="width: 100%"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-date-picker
              type="datetime"
              placeholder="结束日期"
              v-model="orderForm.end_created_at"
              style="width: 100%"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <!-- 上下切换的按钮 -->
        <div class="drop-down-wrap">
          <transition name="el-fade-in-linear">
            <el-button
              v-if="!dropStatus"
              type="text"
              icon="iconfont icon-xiangxiashuangjiantou"
              style="
                background: #fff;
                border: none;
                color: #666;
                font-size: 24px;
                padding: 0;
              "
              @click="dropHandler"
            ></el-button>
            <el-button
              v-if="dropStatus"
              type="text"
              icon="iconfont icon-xiangshangshuangjiantou"
              style="
                background: #fff;
                border: none;
                color: #666;
                font-size: 24px;
                padding: 0;
              "
              @click="dropHandler"
            ></el-button>
          </transition>
        </div>
        <el-collapse-transition>
          <div v-show="dropStatus">
            <el-form-item label="要求发货日">
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="开始日期"
                  v-model="orderForm.start_out_ware_day"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="结束日期"
                  v-model="orderForm.end_out_ware_day"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-form-item>

            <!-- <el-form-item label="快递单号" v-if="isZhifaOrFactory">
              <el-input v-model="orderForm.courierNumber"></el-input>
            </el-form-item> -->
            <!-- <el-form-item
              label="通知物流状态"
              v-if="isZhifa"
              label-width="90px"
            >
              <el-select
                v-model="orderForm.isTs"
                placeholder="请选择"
                clearable
              >
                <el-option label="通知中" :value="1"> </el-option>
                <el-option label="通知成功" :value="2"> </el-option>
                <el-option label="未通知" :value="3"> </el-option>
              </el-select>
            </el-form-item> -->
            <!-- v-if="!isFactory"
            <el-form-item
              label="是否生成箱码"
              label-width="80px"
            >
              <el-select
                v-model="orderForm.isBoxnum"
                placeholder="请选择"
                clearable
              >
                <el-option label="是" :value="1"> </el-option>
                <el-option label="否" :value="0"> </el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item
              label="物流状态"
              label-width="60px"
              v-if="isZhifa && statusActive === 4 && canInputTs"
            >
              <el-select
                v-model="orderForm.tsStatus"
                placeholder="仅筛选当前页面数据"
                clearable
              >
                <el-option
                  v-for="item in tsStatusList"
                  :label="item.text"
                  :value="item.value"
                  :key="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item
              label="物流通知方式"
              label-width="80px"
              v-if="isZhifa && statusActive === 4 && canInputTs"
            >
              <el-select
                v-model="orderForm.courier_type"
                placeholder="请选择"
                clearable
              >
                <el-option label="系统通知" :value="1"> </el-option>
                <el-option label="非系统通知" :value="2"> </el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item
              label="物流单号更新状态"
              label-width="100px"
              v-if="isZhifa && statusActive === 4 && canInputTs"
            >
              <el-select
                v-model="orderForm.courier_odd_status"
                placeholder="请选择"
                clearable
              >
                <el-option label="更新中" :value="1"> </el-option>
                <el-option label="更新成功" :value="2"> </el-option>
                <el-option label="更新失败" :value="-1"> </el-option>
                <el-option label="更新失败(可重试)" :value="-2"> </el-option>
              </el-select>
            </el-form-item> -->
          </div>
        </el-collapse-transition>
        <el-form-item>
          <el-button type="primary" @click="searchOrderList" size="small"
            >查询</el-button
          >
          <el-button size="small" type="primary" @click="exportOrder"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 查询表格结果 -->
    <div class="tableTitle">
      <!-- <span>查询结果：</span>
      <span class="info">提示：请及时接单,超时系统自动拒单</span> -->
      <div class="tableStatus">
        <!-- tab栏 -->
        <div>
          <!-- <div
            class="status"
            @click="getTableStatus(1)"
            :class="{ active: statusActive === 1 }"
          >
            <p>待接单</p>
          </div> -->
          <!-- <div
            class="status"
            @click="getTableStatus(2)"
            :class="{ active: statusActive === 2 }"
          >
            <p>备货中</p>
          </div> -->
          <div
            class="status"
            @click="getTableStatus(3)"
            :class="{ active: statusActive === 3 }"
          >
            <p>待处理</p>
          </div>
          <div
            class="status"
            @click="getTableStatus(4)"
            :class="{ active: statusActive === 4 }"
          >
            <p>今日出库</p>
          </div>
          <!-- <div
            class="status"
            @click="getTableStatus(5)"
            :class="{ active: statusActive === 5 }"
          >
            <p>失效</p>
          </div> -->
          <!-- <div
            v-if="statusActive == 4"
            flex="main:center cross:center"
            style="margin-top: 5px; margin-left: 10px"
          >
            <el-checkbox
              v-model="orderForm.outware_timeout"
              @change="
                () => {
                  getTableStatus(4);
                }
              "
              >已出库超时未到分仓</el-checkbox
            >
          </div> -->
        </div>
        <!-- tab栏右边操作按钮 -->
        <div class="btns">
          <!-- <el-dropdown
            trigger="click"
            size="medium"
            placement="bottom"
            class="batchbtn"
            style="margin-left: 15px"
            @command="handleCommand"
            v-show="
              (statusActive === 4 && isZhifaOrFactory && canInputTs) ||
              (statusActive === 3 && isZhifaOrFactory && canInputTs)
            "
          >
            <el-button type="primary" size="small"> 录入物流运单 </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="b">录入全部</el-dropdown-item>
              <el-dropdown-item command="a">录入勾选</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- <el-button
            size="small"
            type="primary"
            @click="quickSetBoxNum(false)"
            v-show="statusActive === 3 && !isFactory"
            class="blue"
            >快速订单打包</el-button
          > -->
          <!-- <el-button
            size="small"
            type="primary"
            @click="logisticsGetGoods(false)"
            v-show="statusActive === 3 && isZhifaOrFactory"
            v-if="!isFactory"
            >通知物流取货</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="acceptGoods"
            v-show="statusActive === 1"
            >接单</el-button
          > -->
          <el-button
            size="small"
            type="primary"
            v-show="statusActive === 3"
            @click="printStockList"
            class="blue"
            >每日备货清单</el-button
          >

          <!-- <el-button
            size="small"
            type="primary"
            @click="autoPareDoneHandler"
            v-show="statusActive === 2"
            >备货完成</el-button
          >
          <el-button
            size="small"
            type="primary"
            v-show="statusActive === 4"
            @click="completeGoods"
            >订单打包</el-button
          > -->
          <!-- v-if="!isFactory" -->
          <el-button
            size="small"
            type="primary"
            @click="outGoods(false)"
            v-show="statusActive === 3"
            >出库</el-button
          >
          <!-- <el-button
            size="small"
            type="primary"
            @click="factoryOutGoods('dialogCancel')"
            v-if="isFactory"
            v-show="statusActive === 3"
            >出库</el-button
          > -->
          <el-button
            size="small"
            type="primary"
            v-show="statusActive === 4"
            @click="printOutwareList"
            >打印出库清单</el-button
          >
          <!-- <el-button
            size="small"
            type="primary"
            @click="cancelGoods"
            v-show="showCancelGoods"
            >取消备货</el-button
          > -->
          <el-button
            size="small"
            type="primary"
            @click="print(false)"
            v-show="statusActive === 3"
            >打印全部箱码</el-button
          >
          <!-- <el-button
            size="small"
            type="primary"
            @click="exportGoodsListHandler"
            v-show="statusActive === 3"
            >导出货物清单</el-button
          > -->
          <!-- <el-button
            size="small"
            type="primary"
            @click="prinPurchaseHandler"
            v-show="statusActive === 3"
            v-if="isZhifaOrFactory"
            >打印采购订单</el-button
          > -->

          <!-- <el-button
            size="small"
            type="primary"
            @click="inputTsHandler"
            v-show="(statusActive === 4 && isZhifaOrFactory && canInputTs) || (statusActive === 3 && isZhifaOrFactory && canInputTs)"
          >录入物流运单</el-button> -->
          <!-- <el-button
            size="small"
            type="primary"
            @click="exportOrder"
          >导出</el-button>-->
          <!-- <el-button
          class="editBtn"
          size="small"
          type="primary"
           @click="editOrder"
          >编辑/保存</el-button>-->
        </div>
      </div>
    </div>
    <!-- table表格 -->
    <order-table
      ref="orderTable"
      v-loading="loadOrderTable"
      @getDetailTable="getDetailTable"
      @getBoxData="getBoxData"
      @updateOrder="getOrderList"
      @getSelectOrderData="getSelectOrderData"
      @acceptGoodsOk="acceptGoodsOk"
      @editOrder="editOrderHandler"
      @getTransportDetail="getTransportDetail"
      @getDetailAsyncStatus="getDetailAsyncStatus"
      :orderTableData="orderTableData"
      :statusActive="statusActive"
    ></order-table>
    <order-print-table :orderTableData="orderTableData"></order-print-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size.sync="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
    <!-- 商品信息 -->
    <p class="goodsInfo">商品信息</p>
    <!-- 商品信息的表格 -->
    <order-detail-table
      @updateOrder="getOrderList"
      :orderDetailTableData="orderDetailTableData"
    ></order-detail-table>
    <!-- 弹出框 -->
    <order-dialog ref="orderDialog" :boxData="boxData"></order-dialog>
    <!-- 是否取消备货出库弹出框 -->
    <!-- <cancel-pare-dialog
      @cancelOrder="cancelOrder"
      ref="cancelPareDialog"
    ></cancel-pare-dialog> -->
    <!-- 已备货 编辑 导出货物清单 -->
    <delivery-sheet
      ref="deliverySheet"
      :id="selectOrderDataId"
      :ids="selectOrderData"
      v-if="showdeliverySheet"
      v-show="false"
    ></delivery-sheet>
    <!-- 取消订单提醒 弹出框 -->
    <order-cancel-dialog
      v-if="cancelOrderDialog"
      :dialog="cancelOrderDialog"
      :table="cancelDialogTable"
      @cancel="cancelDialogHandler"
      @confirm="cancelDialogConfirmHandler"
    ></order-cancel-dialog>
    <!-- xxx子订单详情 -->
    <transport-detail-dialog
      v-if="showTransportDetailDialog"
      :dialog="showTransportDetailDialog"
      :row="TransportDetailDialogRow"
      @cancel="() => (showTransportDetailDialog = false)"
    ></transport-detail-dialog>
    <el-dialog
      :visible.sync="printDialogVisible"
      :append-to-body="true"
      center
      width="500px"
    >
      <span slot="title" style="color: #fff">确认</span>
      <p>
        确认打印<span class="red-color-text">{{ selectOrderData.length }}</span
        >个订单，共<span class="red-color-text">{{ printBoxNumTotal }}</span
        >个打包箱数？
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="printDialogVisible = false" size="mini"
          >取 消</el-button
        >
        <el-button type="primary" @click="print(true)" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="notice"
      :append-to-body="true"
      top="25vh"
      center
      width="580px"
    >
      <span slot="title" style="color: #fff; font-size: 16px"
        >关于调整店铺管理系统箱码打印方式的通知</span
      >
      <p style="font-size: 16px">
        店铺管理系统的箱码打印方式调整，变更为浏览器打印。打印操作说明详见
        <a @click="goNotice" class="notice">【公告中心】-【打印指导】。</a>
      </p>
      <p style="font-size: 16px">调整生效时间：2019年9月5日20:00点。</p>
      <p style="text-align: right; font-weight: 600">锐锢商城</p>
      <p style="text-align: right; font-weight: 600">2019年9月5日</p>
    </el-dialog>
    <el-dialog
      :visible.sync="outGoodsDialog"
      :append-to-body="true"
      top="25vh"
      center
      width="580px"
    >
      <span slot="title" style="color: #fff; font-size: 16px">出库确认</span>
      <p>请确认是否出库</p>
      <p style="color: red; font-weight: bold">
        一旦出库，则订单无法再更改状态
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outGoodsDialog = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="factoryOutGoods('sureOut')"
          size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <boxcode ref="boxcode" v-show="false"></boxcode>
    <!-- 2021.06.01 同步信息弹窗 -->
    <el-dialog
      :visible.sync="orderSyncDialogVisible"
      :append-to-body="true"
      title="对接详情"
      width="580px"
    >
      <p>
        <span>批次号：</span><span>{{ orderSyncInfo.main_number }}</span>
      </p>
      <p>
        <span>同步时间：</span
        ><span>{{ orderSyncInfo.async_create_time }}</span>
      </p>
    </el-dialog>
  </div>
</template>
<script>
import { changeDateString, getOdStatusList } from "@/utils/utils";
import {
  getOrderList,
  listBox,
  getListWrongDetail,
  getOrderDetail,
  printLogisticsSheet,
  getWrongOrder,
  outWare,
  exporOrdertData,
  autoPareDone,
  cancelOrderData,
  // getPurchaseList,
  batchPrintBoxCode,
  getFactoryOrderList,
} from "@/models/orderModel";
import { courierStatusQuery } from "@/models/ts";
import orderTable from "@/components/order/order-table.vue";
import orderPrintTable from "@/components/order/order-print-table.vue";
import cancelPareDialog from "@/components/order/cancelPare-dialog.vue";
import orderDetailTable from "@/components/order/order-detail-table.vue";
import orderDialog from "@/components/order/order-status-dialog.vue";
import TransportDetailDialog from "@/components/order/TransportDetailDialog.vue";
import OrderCancelDialog from "@/components/order/OrderCancelDialog.vue";
import boxcode from "@/components/print/boxcode";
import deliverySheet from "./delivery-sheet.vue";
import { eventBus } from "@/event-bus";
// import { error } from 'util'
// import { truncate } from 'fs'
import moment from "moment";
const tsStatusList = [
  { text: "新建", value: 1 },
  { text: "准备揽件", value: 2 },
  { text: "已取货", value: 3 },
  { text: "配送中", value: 4 },
  { text: "配送完成", value: 5 },
  { text: "非系统通知订单", value: 6 },
  { text: "取消", value: -1 },
];
export default {
  components: {
    orderTable,
    orderPrintTable,
    orderDialog,
    orderDetailTable,
    cancelPareDialog,
    deliverySheet,
    OrderCancelDialog,
    TransportDetailDialog,
    boxcode,
  },
  data() {
    return {
      tsStatusList,
      dropStatus: false,
      isZhifaOrFactory: false,
      isZhifa: false,
      isFactory: false,
      notice: false,
      showdeliverySheet: false, // 导出货物清单 不可见改元素
      orderForm: {
        name: "",
        ruigu_code: "",
        self_code: "",
        order_number: "",
        start_created_at: "", // 推送日期 开始
        end_created_at: "", // 推送日期 结束
        start_out_ware_day: "", // 要求发货 开始
        end_out_ware_day: "", // 要求发货 结束
        od_status: "",
        user_name: "",
        mobile: "",
        address: "",
        instatus: "1", // 3,4待处理 5,6今日出库
        tsStatus: "",
        courier_type: "",
        courier_odd_status: "",
        is_ts: null,
        // is_boxnum: null, // 是否生成箱码
        outware_timeout: "",
        courier_mobile: "", //物流状态值
        // 主单状态
        mainOrderStatus: "",
        // 同步状态
        syncStatus: "",
      },
      pagesize: 10,
      currentPage: 1,
      totalCount: 0,
      orderTableData: [],
      orderDetailTableData: [],
      // od_statusList: [],
      loadOrderTable: true,
      boxData: [],
      selectOrderDataId: "",
      selectOrderData: [],
      statusActive: 3, // 默认显示待处理订单
      selectOrderNo: "",
      cancelOrderDialog: false, // 订单取消弹窗
      cancelDialogTable: {}, // 订单取消弹窗数据
      showTransportDetailDialog: false,
      orderSyncDialogVisible: false, // 订单同步状态弹窗
      orderSyncInfo: {}, // 订单同步状态信息
      TransportDetailDialogRow: {},
      printDialogVisible: false,
      printBoxNumTotal: 0,
      boxcodeList: [],
      showInputTs: false,
      // canInputTs: false, //控制物流状态输入框是否显示
      outGoodsDialog: false, // 出库确认
      // 同步状态
      syncOptions: [],
      // 主单状态
      mainOrderOptions: [],
      // 同步状态是否显示
      syncStatusFlag: null,
      isJgj: localStorage.getItem("is_jgj"),
    };
  },
  computed: {
    showCancelGoods() {
      return (
        this.statusActive === 3 ||
        (this.statusActive === 4 && localStorage.getItem("shop_type") === "0")
      );
    },
  },
  created() {
    let pageIndex = sessionStorage.getItem("order_tab_index_pageIndex");
    if (pageIndex) {
      this.currentPage = Number(pageIndex);
    }
    // if (localStorage.getItem("shop_type") === "2") {
    //   this.canInputTs = true;
    //   this.isFactory = true;
    // }
    // if (localStorage.getItem("shop_type") === "1") {
    //   this.isZhifa = true;
    // }

    // 同步状态是否显示
    let syncStatusFlag = localStorage.getItem("syncStatus");
    if (syncStatusFlag !== "0") {
      this.syncStatusFlag = true;
    } else {
      this.syncStatusFlag = false;
    }
    this.initSelectData();
  },
  mounted() {
    /* if (localStorage.getItem("shop_type") === "3") {
      // this.isZhifaOrFactory = false;
      this.isPingTai = true;
    } */
    // if (
    //   localStorage.getItem("shop_type") === "1" ||
    //   localStorage.getItem("shop_type") === "2"
    // ) {
    //   this.isZhifaOrFactory = true;
    // }

    let pageIndex = sessionStorage.getItem("order_tab_index_pageIndex");
    if (pageIndex) {
      this.currentPage = Number(pageIndex);
    }
    if (localStorage.getItem("orderOutwareTimeout") == "1") {
      this.orderForm.outware_timeout = true;
    }
    let index = sessionStorage.getItem("order_tab_index") || 3;
    
    if (index) {
      this.getTableStatus(Number(index), true);
    }
    // this.getOrderList(true)
    // this.od_statusList = getOdStatusList()
    eventBus.$on("updateOrder", () => {
      this.getTableStatus(3);
      // this.statusActive = 1
      // this.orderForm.instatus = '1'
      // this.getOrderList()
    });

    if (localStorage.getItem("show_notice") === "1") {
      this.notice = false;
    } else {
      if (moment().format("YYYY-MM-DD") < "2019-09-11") {
        this.notice = true;
        localStorage.setItem("show_notice", "1");
      }
    }
  },
  methods: {
    moment,
    dropHandler() {
      this.dropStatus = !this.dropStatus;
    },
    goNotice() {
      this.$router.push({
        path: "/notice/printNotice",
      });
    },
    // 初始筛选项 下拉数据
    initSelectData() {
      this.mainOrderOptions = getOdStatusList().mo_statusList;
      this.syncOptions = getOdStatusList().syncStatuslist;
    },

    // 导出 邮箱中查收
    async exportOrder() {
      let params = {
        name: this.orderForm.name,
        self_code: this.orderForm.self_code,
        ruigu_code: this.orderForm.ruigu_code,
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number,
        od_status: this.orderForm.od_status,
        user_name: this.orderForm.user_name,
        mobile: this.orderForm.mobile,
        address: this.orderForm.address,
        instatus: this.orderForm.instatus,
      };
      if (this.orderForm.start_created_at) {
        params.start_created_at = changeDateString(
          this.orderForm.start_created_at
        );
      }
      if (this.orderForm.end_created_at) {
        params.end_created_at = changeDateString(this.orderForm.end_created_at);
      }
      if (this.orderForm.start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          this.orderForm.start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.orderForm.end_out_ware_day) {
        params.end_out_ware_day = changeDateString(
          this.orderForm.end_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.statusActive === 5) {
        params.status = "-1";
      } else {
        params.status = "1";
      }

      await exporOrdertData(params);
      // let wb = XLSX.utils.table_to_book(document.querySelector('#out-table'))
      // for (let i in wb.Sheets.Sheet1) {
      //   if (i.indexOf('B') !== -1) {
      //     wb.Sheets.Sheet1[i].z = 'yyyy/m/d h:mm:ss'
      //   } else if (i.indexOf('C') !== -1 && i.indexOf('1') === -1) {
      //     wb.Sheets.Sheet1[i].v = parseInt(wb.Sheets.Sheet1[i].v)
      //   } else if (i.indexOf('D') !== -1) {
      //     wb.Sheets.Sheet1[i].z = '0'
      //   }
      // }
      // let wbout = XLSX.write(wb, {
      //   bookType: 'xlsx',
      //   bookSST: true,
      //   type: 'array'
      // })
      // try {
      //   let fileName = currentTime() + '.xlsx'
      //   FileSaver.saveAs(
      //     new Blob([wbout], {
      //       type: 'application/octet-stream'
      //     }),
      //     fileName
      //   )
      // } catch (e) {
      //   if (typeof console !== 'undefined') console.log(e, wbout)
      // }
      // return wbout
    },
    // 每日备货清单
    printStockList() {
      this.$router.push("/order/dayStockList");
    },
    // 打印出库清单
    printOutwareList() {
      this.$router.push("/order/shippingList");
    },
    //获取tab栏装填
    getTableStatus(index, isReturnBack) {
      if (!isReturnBack) {
        this.currentPage = 1;
        sessionStorage.setItem("order_tab_index_pageIndex", 1);
      }
      this.statusActive = index;
      sessionStorage.setItem("order_tab_index", index);
      this.orderDetailTableData = [];
      this.pagesize = 10;
      switch (index) {
        case 3:
          this.orderForm.instatus = "3,4";
          break;
        case 4:
          this.orderForm.instatus = "5,6";
          break;
      }
      this.getOrderList();
    },
    // 获取选择的订单 勾选
    getSelectOrderData(val) {
      this.showdeliverySheet = false;
      this.selectOrderData = val;
      if (this.statusActive === 1 && val.length !== 0) {
        let listId = [];
        let listNo = [];
        val.forEach((n, i) => {
          listId.push(n.id);
          listNo.push(n.main_number);
        });
        this.selectOrderDataId = listId.join(",");
        this.selectOrderNo = listNo.join(",");
      } else if (val.length !== 0) {
        this.selectOrderDataId = val[0].id;
        this.selectOrderNo = val[0].main_number;
      }
    },
    // 勾选数据
    ifSelectData() {
      if (!this.selectOrderData || this.selectOrderData.length === 0) {
        this.$message.warning("请勾选列表");
        return false;
      } else {
        return true;
      }
    },
    // 接单
    acceptGoods() {
      if (this.ifSelectData()) {
        this.orderDetailTableData = [];
        this.$refs.orderTable.acceptGoods(this.selectOrderDataId);
      }
    },
    // 接单成功进入备货中  不跳转
    acceptGoodsOk() {
      // this.getTableStatus(2)
    },
    // 订单打包
    completeGoods() {
      if (this.ifSelectData()) {
        if (this.selectOrderData.length > 1) {
          this.$message.warning("只能选择一个");
        } else {
          localStorage.setItem(
            "orderData",
            JSON.stringify(this.selectOrderData)
          );
          if (
            (this.statusActive === 3 &&
              localStorage.getItem("shop_type") === "1") ||
            localStorage.getItem("shop_type") === "2"
          ) {
            // 已备货且为直发可以通知物流取货
            this.$router.push({
              path: "/order/completeStock",
              query: { id: this.selectOrderDataId, showLogisticsSheet: "true" },
            });
          } else {
            this.$router.push({
              path: "/order/completeStock",
              query: { id: this.selectOrderDataId },
            });
          }
        }
        // this.$refs.orderTable.completeGoods(this.selectOrderDataId)
      }
    },
    // 已备货页签 编辑订单
    editOrderHandler(id) {
      // if (this.ifSelectData()) {
      localStorage.setItem("orderData", JSON.stringify(this.selectOrderData));
      if (
        (this.statusActive === 3 &&
          localStorage.getItem("shop_type") === "1") ||
        localStorage.getItem("shop_type") === "2"
      ) {
        // 已备货且为直发可以通知物流取货
        this.$router.push({
          path: "/order/completeStock",
          query: { id: id, showLogisticsSheet: "true" },
        });
      } else {
        this.$router.push({ path: "/order/completeStock", query: { id: id } });
      }
      // this.$refs.orderTable.completeGoods(this.selectOrderDataId)
      // }
    },
    // 取消备货
    /* cancelGoods() {
      if (this.ifSelectData()) {
        if (this.selectOrderData.length > 1) {
          this.$message.warning("只能勾选一个");
        } else {
          this.$refs.cancelPareDialog.cancelPareVisible = true;
          this.$refs.cancelPareDialog.orderNoGroups = this.selectOrderNo;
        }
      }
    } ,*/
    /* cancelOrder() {
       this.$refs.orderTable.cancelGoods(this.selectOrderDataId);
    }, */
    // 出库 next =false 平台需要确认弹窗
    async outGoods(next, isFactoryConfirm) {
      // 直发
      if (this.isZhifa) {
        if (localStorage.getItem("need_scan") === "0") {
          // 不需要扫描
          if (this.selectOrderData.length >= 1) {
            let arr = [];
            this.selectOrderData.forEach((item) => {
              arr.push(item.id);
            });

            let params = {
              ids: arr.join(","),
            };
            let data = await outWare(params);
            if (data.message === "Success") {
              this.getOrderList();
            }
          } else {
            this.$message.warning("请勾选列表");
          }
        } else {
          this.$router.push("/order/scanningStock");
        }
        return;
      }

      // 平台
      if (!next) {
        cancelOrderData({
          ids: "",
        }).then((res) => {
          if (res.code === 200) {
            if (res.data.detail_count < 1) {
              this.outGoods(true);
            } else {
              this.cancelDialogTable = res.data;
              this.cancelOrderDialog = true;
            }
          }
        });
      } else {
        if (localStorage.getItem("need_scan") === "0") {
          // 不需要扫描
          let arr = [];
          this.selectOrderData.forEach((item) => {
            arr.push(item.id);
          });
          let params = {
            ids: arr.join(","),
          };
          let data = await outWare(params);
          if (data.message === "Success") {
            this.getOrderList();
            // this.getTableStatus(4)  不跳转
          }
        } else {
          this.$router.push("/order/scanningStock");
        }
      }
    },
    // 出库 工厂
    async factoryOutGoods(val) {
      if (localStorage.getItem("need_scan") === "0") {
        // 不需要扫描
        if (this.selectOrderData.length >= 1) {
          // 订单取消提醒弹窗
          if (val === "dialogCancel") {
            cancelOrderData({
              ids: this.selectOrderData
                .map((item) => {
                  return item.id;
                })
                .join(","),
            }).then((res) => {
              if (res.code === 200) {
                if (res.data.detail_count < 1) {
                  this.factoryOutGoods("confirm");
                } else {
                  this.cancelDialogTable = res.data;
                  this.cancelOrderDialog = true;
                }
              }
            });
            return;
          }
          // 确认提醒弹窗
          if (val === "confirm") {
            this.outGoodsDialog = true;
            return;
          }
          // 出库
          if (val === "sureOut") {
            let arr = [];
            this.selectOrderData.forEach((item) => {
              arr.push(item.id);
            });
            let params = {
              ids: arr.join(","),
            };
            let data = await outWare(params);
            if (data.message === "Success") {
              this.getOrderList();
            }
            this.outGoodsDialog = false;
            this.cancelOrderDialog = false;
          }
        } else {
          this.$message.warning("请勾选列表");
        }
      } else {
        this.$router.push("/order/scanningStock");
      }
    },
    // 获取单条订单详情
    async getDetailTable(row) {
      let params;
      let data;
      if (this.statusActive === 5) {
        params = {
          id: row.mo_id,
        };
        data = await getWrongOrder(params);
      } else {
        params = {
          id: row.id,
        };
        data = await getOrderDetail(params);
      }
      for (let i of data) {
        i.mo_statusName = getOdStatusList().statusList.filter(
          (item) => item.value === i.status
        )[0].label;
      }
      this.orderDetailTableData = data;
    },
    // async getDetailTable (id) {
    //   let params = { order_number: id }
    //   let data = await getOrderListDetail(params)
    //   console.log(data)
    //   this.orderDetailTableData = data
    // },
    async getBoxData(row) {
      let params = { id: row.id };
      let data = await listBox(params);
      this.boxData = data;
      if (data) {
        for (let i of data) {
          i.status = row.od_statusName;
          // if (i.status === '2') {
          // } else if (i.status === '1') {
          //   i.status = '未到分仓'
          // }
        }
        this.$refs.orderDialog.boxDialogVisible = true;
        this.$refs.orderDialog.orderNo = `主订单号：${row.main_number}`;
      }
    },
    // 打印箱码
    async print(val) {
      if (this.ifSelectData()) {
        if (!val) {
          this.printDialogVisible = true;
          let boxNumTotal = [];
          this.selectOrderData.forEach((item) => {
            if (item.box_num) {
              boxNumTotal.push(item.box_num);
            }
          });
          this.printBoxNumTotal = boxNumTotal
            .reduce((pre, curr) => {
              return Number(pre) + Number(curr);
            }, 0)
            .toFixed(0);
        } else {
          // this.$refs.orderTable.print(this.selectOrderData)
          let boxcodeList = [...this.selectOrderData];
          let ids = [];
          let failedData = [];
          boxcodeList.forEach((item) => {
            ids.push(item.id);
          });
          let params = {
            ids: JSON.stringify(ids),
          };
          let res = await batchPrintBoxCode(params);
          if (res.code === 200) {
            let success = res.data.succeed;
            failedData = res.data.failed;
            if (failedData.length > 0) {
              failedData.forEach((item) => {
                item.main_number = boxcodeList.find((order) => {
                  return order.id === item.id;
                }).main_number;
              });
              let html = "";
              failedData.forEach((item) => {
                html +=
                  '<p style="padding:5px;">主订单号：' +
                  item.main_number +
                  "," +
                  item.msg +
                  "</p>";
              });
              this.$message({
                showClose: true,
                type: "error",
                iconClass: "11",
                dangerouslyUseHTMLString: true,
                message: html,
                duration: 0,
              });
            } else {
              let printData = [];
              for (const key in success) {
                if (success.hasOwnProperty(key)) {
                  let item = success[key];
                  for (let i of item) {
                    i.code = i.serial_number;
                    i.print_interval = 5;

                    printData.push(i);
                  }
                }
              }
              this.$refs.boxcode.myPrint(printData);
              this.printDialogVisible = false;
            }
          }
          // this.boxcodeList = boxcodeList
          // console.log(boxcodeList, 'this.selectOrderData')
          // this.$refs.boxcode.myPrint(boxcodeList)
          // this.printDialogVisible = false
        }
      }
    },

    // 搜索
    searchOrderList() {
      this.currentPage = 1;
      this.getOrderList();
    },
    // 平台直发获取订单列表   紧固件
    async getCommonOrderList(isReturnBack) {
      this.loadOrderTable = true;
      let params = {
        name: this.orderForm.name,
        self_code: this.orderForm.self_code,
        ruigu_code: this.orderForm.ruigu_code,
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number,
        od_status: this.orderForm.od_status,
        user_name: this.orderForm.user_name,
        mobile: this.orderForm.mobile,
        address: this.orderForm.address,
        instatus: this.orderForm.instatus, // tab栏状态
        page: this.currentPage,
        pagesize: this.pagesize,
        serial_number: this.orderForm.serialNumber,
        courier_number: this.orderForm.courierNumber,
        mo_status: this.orderForm.mainOrderStatus,
        sync_status: this.orderForm.syncStatus,
        outware_today: this.orderForm.instatus === "5,6" ? 1 : "",
      };
      // order_type: 0,  紧固件不需要这个参数

      if (this.orderForm.start_created_at) {
        this.loadOrderTable = true;
        params.start_created_at = changeDateString(
          this.orderForm.start_created_at
        );
      }
      if (this.orderForm.end_created_at) {
        params.end_created_at = changeDateString(this.orderForm.end_created_at);
      }
      if (this.orderForm.start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          this.orderForm.start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.orderForm.end_out_ware_day) {
        params.end_out_ware_day = changeDateString(
          this.orderForm.end_out_ware_day
        ).replace("00:00:00", "");
      }
      if (typeof this.orderForm.isTs === "number") {
        params.is_ts = this.orderForm.isTs;
      }
      // if (typeof this.orderForm.isBoxnum === "number") {
      //   params.is_boxnum = this.orderForm.isBoxnum;
      // }
      if (typeof this.orderForm.courier_odd_status === "number") {
        params.courier_odd_status = this.orderForm.courier_odd_status;
      }
      if (typeof this.orderForm.courier_type === "number") {
        params.courier_type = this.orderForm.courier_type;
      }
      if (this.orderForm.outware_timeout && this.orderForm.instatus == "5,6") {
        params.outware_timeout = 1;
      }
      // 物流状态值
      // if (
      //   (this.statusActive === 4 && this.isZhifaOrFactory && this.canInputTs) ||
      //   (this.statusActive === 3 && this.isZhifaOrFactory && this.canInputTs)
      // ) {
      //   params.courier_mobile = this.orderForm.courier_mobile;
      // }
      let data = await getOrderList(params);
      let list = data.list || [];
      if (this.statusActive === 4 && this.isZhifaOrFactory && this.canInputTs) {
        list.forEach((item) => {
          item.ts_status = "";
        });
      }
      this.orderTableData = list;
      this.totalCount = data.total;
      // 设置单据状态
      for (let i of this.orderTableData) {
        let odStatusName = getOdStatusList().mo_statusList.filter((item) => {
          return item.value === i.mo_status;
        });
        if (odStatusName.length === 0) {
          i.od_statusName = "其他";
        } else {
          i.od_statusName = odStatusName[0].label;
        }
      }
      // 同步状态 名称转换
      this.orderTableData.map((item, index) => {
        let syncStatusName = getOdStatusList().syncStatuslist.filter(
          (citem) => {
            return citem.value == item.async_create_status;
          }
        );
        item.async_create_statusName = syncStatusName[0].label;
      });
      this.loadOrderTable = false;

      if (this.isZhifa) {
        // 快递单号转态 承运商 zhifa
        if (this.statusActive === 4 && this.canInputTs) {
          let orderTableTs = this.orderTableData.map((item) => {
            return {
              id: item.id,
              main_number: item.main_number,
            };
          });
          if (orderTableTs.length > 0) {
            let status = await courierStatusQuery({
              item: JSON.stringify(orderTableTs),
            });
            if (status.code === 200) {
              let data = status.data.succeed;
              if (data && data.length > 0) {
                this.orderTableData.forEach((item) => {
                  let order = data.find((st) => {
                    return st.id == item.id;
                  });
                  if (order) {
                    item.ts_status = order.delivery_code;
                  }
                });
              }
            }
          }
        }
      }
      if (typeof this.orderForm.tsStatus === "number") {
        let arr = this.orderTableData.filter((item) => {
          return item.ts_status === this.orderForm.tsStatus;
        });
        this.orderTableData = arr;
      }
    },
    // isReturnBack 是否从其他位置返回该页面
    async getOrderList(isReturnBack) {
      // 紧固件
      if (localStorage.getItem("is_jgj") === "1") {
        this.getCommonOrderList(isReturnBack);
      }
    },
    serachOrder() {},
    // 每页条数改变
    handleSizeChange(val) {
      this.pagesize = val;
      this.getOrderList();
    },
    // 页码改变
    handleCurrentChange(val) {
      sessionStorage.setItem("order_tab_index_pageIndex", val);
      this.currentPage = val;
      this.getOrderList();
    },
    // 备货完成
    autoPareDoneHandler() {
      if (this.selectOrderData.length > 0) {
        let arr = [];
        this.selectOrderData.forEach((item) => {
          arr.push(item.id);
        });
        autoPareDone({ ids: arr.join(",") }).then((res) => {
          if (res.code === 200) {
            this.getOrderList();
          }
        });
      } else {
        this.$message.warning("请勾选列表");
      }
    },
    // 导出货物清单
    exportGoodsListHandler() {
      if (this.ifSelectData()) {
        this.showdeliverySheet = true;
        this.$nextTick(function () {
          this.$refs.deliverySheet.print();
        });
        console.log(this.selectOrderData, "selectOrderDataId");
        // if (this.selectOrderData.length > 1) {
        //   this.$message.warning('只能选择一个')
        // } else {
        //   this.showdeliverySheet = true
        //   this.$nextTick(function () {
        //     this.$refs.deliverySheet.print()
        //   })
        // }
      }
    },
    // 通知物流取货
    async logisticsGetGoods(next) {
      if (this.ifSelectData()) {
        if (!next) {
          cancelOrderData({
            ids: this.selectOrderData
              .map((item) => {
                return item.id;
              })
              .join(","),
          }).then((res) => {
            if (res.code === 200) {
              if (res.data.detail_count < 1) {
                this.logisticsGetGoods(true);
              } else {
                this.cancelDialogTable = res.data;
                this.cancelOrderDialog = true;
              }
            }
          });
        } else {
          let arr = [];
          this.selectOrderData.forEach((item) => {
            arr.push(item.id);
          });
          let params = {
            ids: arr.join(","),
          };
          let res = await printLogisticsSheet(params);
          if (res.code === 200) {
            let data = res.data;
            if (data.length === 0) {
              this.$message.warning(
                "已发送请求，通知物流结果在2-3分钟后返回,可刷新页面查看"
              );
              this.getOrderList();
            } else {
              let htmlStr =
                '<p style="padding:5px;color:red;">通知物流结果在2-3分钟后返回,可刷新页面查看</p>';
              this.orderTableData.forEach((item) => {
                data.forEach((erritem) => {
                  if (item.id === erritem.id) {
                    htmlStr += `<p style="padding:5px;color:#000;">${item.main_number}:${erritem.msg}</p>`;
                  }
                });
              });
              this.$message({
                dangerouslyUseHTMLString: true,
                duration: 5000,
                message: htmlStr,
                type: "error",
                showClose: true,
              });
              this.getOrderList();
            }
          } else {
            this.$message.error(res.message);
          }
        }

        // this.getOrderList()
        // this.$router.push('/order/deliverySheet?id=' + this.selectOrderDataId)
      }
    },
    // 取消订单提醒弹窗
    cancelDialogHandler() {
      this.cancelOrderDialog = false;
    },
    // 确认订单出库提醒
    cancelDialogConfirmHandler() {
      if (this.isZhifa) {
        // 直发
        this.logisticsGetGoods(true);
        this.cancelOrderDialog = false;
        return;
      }
      if (this.isFactory) {
        // 工厂
        this.factoryOutGoods("confirm");

        return;
      }
      // 平台
      this.outGoods(true);
      this.cancelOrderDialog = false;
    },
    // 打印采购订单
    prinPurchaseHandler() {
      this.$router.push("/order/prinPurchase");
      // getPurchaseList({
      //   is_purchase: 0
      // })
    },
    // 查看子单号
    getTransportDetail(row) {
      this.showTransportDetailDialog = true;
      this.TransportDetailDialogRow = row;
    },
    // 查看同步状态信息
    getDetailAsyncStatus(row) {
      //console.log(row.main_number, row.async_create_time)
      this.orderSyncDialogVisible = true;
      this.orderSyncInfo = {
        main_number: row.main_number,
        async_create_time: row.async_create_time,
      };
    },
    // 快速设置打包
    quickSetBoxNum() {
      if (this.ifSelectData()) {
        this.$router.push({
          path: "/order/QuickSetBoxNum",
          query: {
            params: this.selectOrderData,
          },
        });
      }
    },
    // 录入物流运单
    handleCommand(val) {
      if (val === "b") {
        this.inputTsHandler("all");
      }
      if (val === "a") {
        this.inputTsHandler();
      }
    },
    // 录入物流运单
    inputTsHandler(status) {
      if (status === "all") {
        this.$router.push({
          path: "/order/inputTS",
          query: {
            ids: "",
            orderType: this.orderForm.instatus,
            isAll: "YES",
          },
        });
      } else {
        if (this.selectOrderData.length > 0) {
          let arr = [];
          this.selectOrderData.forEach((item) => {
            arr.push(item.id);
          });
          this.$router.push({
            path: "/order/inputTS",
            query: {
              ids: JSON.stringify(arr.join(",")),
              orderType: this.orderForm.instatus,
              isAll: "NO",
            },
          });
        } else {
          this.$message.warning("请选择订单");
        }
      }
    },
  },
};
</script>
<style lang="scss">
.order {
  .el-form .el-form-item__label {
    width: 65px;
    white-space: nowrap;
  }
  .el-button.blue {
    color: #409eff;
    background-color: #409eff;
    border-color: #409eff;
    color: #fff;
  }
  .tableTitle {
    margin-bottom: 2px;
    margin-top: 10px;
    padding-top: 5px;
    border-top: 1px solid #ddd;
    span {
      font-size: 12px;
    }
    .info {
      color: red;
    }
    .tableStatus {
      display: flex;
      justify-content: space-between;
      div {
        display: flex;
      }
      .status {
        cursor: pointer;
        height: 30px;
        width: 80px;
        margin-right: 1px;
        margin-top: 5px;
        border-radius: 8px 8px 0px 0px;
        background-color: rgb(115, 129, 140);
        p {
          color: #fff;
          font-size: 14px;
          width: 100%;
          text-align: center;
          line-height: 4px;
        }
      }
      .status.active,
      .status:hover {
        background-color: rgb(164, 180, 193);
      }
    }
    p {
      line-height: 10px;
    }
    .btns {
      margin-top: 5px;
      .editBtn {
        background-color: #409eff;
        border-color: #409eff;
      }
    }
  }
  .goodsInfo {
    border-top: 1px solid #ddd;
  }
}
.red-color-text {
  color: red;
  font-size: 20px;
  font-weight: bold;
  display: inline-block;
  padding: 0 5px;
}
.notice {
  color: #409eff;
  cursor: pointer;
}
.serch-wrap {
  position: relative;
  padding-right: 50px;
}
.drop-down-wrap {
  position: absolute;
  right: 20px;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/orderFastener.vue